<form autocomplete="off">
  <mat-form-field>
    <mat-label>Species</mat-label>
    <input matInput spellcheck="false" [formControl]="input" [matAutocomplete]="auto">
  </mat-form-field>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" [autoActiveFirstOption]="true">
    <mat-option class="option-suffix-icon" *ngFor="let species of filteredSpecies$ | async" [value]="species">
      {{ species.name | titlecase }}
      <mat-icon *ngIf="!species.default" (click)="removeSpecies(species); $event.stopPropagation()">close</mat-icon>
    </mat-option>
    <mat-option *ngIf="showAddSpecies$ | async" [value]="input.value" (click)="addSpecies(input.value)">
      Add <b>{{ (input.value?.name ? input.value.name : input.value) | titlecase }}</b> to species
    </mat-option>
  </mat-autocomplete>
</form>
<mat-chip-list>
  <mat-chip *ngFor="let species of species$ | async"
    [selected]="isSelected(species)"
    (tap)="onChipTap(species, $event)"
    (press)="onChipPress(species)"
    (blur)="showRemove$.next(null)">
    {{ species.name | titlecase }}
    <mat-icon matChipRemove *ngIf="showRemove(species)" (click)="removeSpecies(species)">cancel</mat-icon>
  </mat-chip>
</mat-chip-list>